import React, { FunctionComponent, useState } from 'react'
import { useIntl } from 'react-intl'
import { View } from 'react-native'

import styled from 'styled-components/native'

import { CheckboxButtonType } from '@lyrahealth-inc/shared-app-logic/src/models/formMetadata/FormMetadata'

import { tID } from '../../utils/utils'
import { CheckboxGroup, CheckBoxGroupOptionProps } from '../formElements/CheckboxGroup'
import { SecondaryButton } from '../secondaryButton/SecondaryButton'

const Container = styled.View({
  padding: 16,
  minWidth: 280,
})

const ButtonsContainer = styled.View({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginTop: 16,
  gap: 8,
})

export interface FilterOptions {
  data: Array<{ group?: number; id: string; text: string }>
}

export interface FilterButtonModalProps {
  filterName: string
  filterOptions: FilterOptions
  filterArray: Array<string>
  saveOnClick: (filterArray: Array<string>) => void
  closeModal?: () => void
}

export const FilterButtonModal: FunctionComponent<FilterButtonModalProps> = ({
  filterName,
  filterOptions,
  filterArray,
  saveOnClick,
  closeModal,
}) => {
  const { formatMessage } = useIntl()
  const [filterArrayState, setFilterArrayState] = useState<Array<string>>(filterArray)

  const options: CheckBoxGroupOptionProps[] = filterOptions.data.map((item) => ({
    id: item.id,
    text: item.text,
    group: item.group,
  }))

  const handleClear = () => {
    setFilterArrayState([])
  }

  const handleSave = () => {
    saveOnClick(filterArrayState)
    closeModal?.()
  }

  return (
    <Container testID={tID('FilterButtonModal')}>
      <View>
        <CheckboxGroup
          name={`${filterName}-filter`}
          label={`${filterName} Filter`}
          subLabel={formatMessage({
            defaultMessage: 'Select all that apply',
            description: 'Instruction text for filter checkbox selection',
          })}
          options={options}
          value={filterArrayState}
          onChange={(array) => setFilterArrayState(array as string[])}
          buttonType={CheckboxButtonType.TEXT_OUTLINE}
        />
      </View>
      <ButtonsContainer>
        <SecondaryButton
          text={formatMessage({ defaultMessage: 'Clear', description: 'Button to clear filter selections' })}
          onPress={handleClear}
          disabled={!filterArrayState.length}
          testID={tID('FilterButtonModal-clear')}
        />
        <SecondaryButton
          text={formatMessage({ defaultMessage: 'Save', description: 'Button to save filter selections' })}
          onPress={handleSave}
          testID={tID('FilterButtonModal-save')}
        />
      </ButtonsContainer>
    </Container>
  )
}

export default FilterButtonModal
